import { urlToKey, getSheet } from 'sheetsy'

export default function initFormFill() {

  if ($('#apartmentSelection').length > 0) {
    let link = 'https://docs.google.com/spreadsheets/d/1g0JJpL3wqXo9kEL48LJi9Sl0W0W55zLwBpGMc9LGT9A/edit?usp=sharing'
    let key = urlToKey(link)
    console.log('Found field to fill')
    getSheet(key, 'od6').then(sheet => {
      const apartments = sheet.rows
      apartments.map(apartment => {
        if (apartment.status.toLowerCase() == 'wolne') {
          var o = new Option(apartment.id, 'value');
          $(o).html(`Lokal ${apartment.id}`);
          $('#apartmentSelection').append(o);
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/formFill.js